import { render, staticRenderFns } from "./EventsAgenda.vue?vue&type=template&id=26c18a58&scoped=true&"
import script from "./EventsAgenda.vue?vue&type=script&lang=ts&"
export * from "./EventsAgenda.vue?vue&type=script&lang=ts&"
import style0 from "./EventsAgenda.vue?vue&type=style&index=0&id=26c18a58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c18a58",
  null
  
)

export default component.exports